<style lang="scss" scoped>
.accordion {
  margin-bottom: 30px;
}

.managementbutton {
  margin-top: 30px;
}

.padding-tb {
  padding-top: 10px;
  padding-bottom: 10px;
}

.outer-file-list {
  //border: 1px solid $c-dark-gray;
  padding: 15px;
  margin: 20px 0;
}

.active {
  transition: none;
}

button .smdtooltip {
  top: 0;
  left: 0;
}

.udropdowncontainer {
  .label {
    padding: 5px;
  }
  &.active {
    border-bottom: 3px solid $c-blue !important;
  }
}

.filterbuttons {
  display: flex;
  gap: 15px;
  align-items: center;

  button {
    font-weight: bold;
    width: auto !important;

    border: 0 !important;
    padding: 2px !important;
    color: $c-dark-grey !important;

    &.active {
      color: $c-blue !important;
      border-color: $c-medium-blue !important;
      border-bottom: 3px solid $c-blue !important;
    }
  }
}

.header {
  background-color: $c-white;
  //border: 1px solid $c-dark-grey !important;
  color: $c-blue !important;
  font-weight: 700 !important;
  text-align: left !important;
  padding: 15px 20px;
  position: relative;
  transition: all 200ms ease;
  margin-bottom: 7px;
  svg {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    fill: $c-blue;
    transition: all 200ms ease;
  }
  &.isOpen {
    svg {
      transform: translateY(-50%) rotate(-45deg);
    }
  }
}
</style>

<template>
  <div id="unitindex">
    <Headline h1="Skillübersicht" :h2="`von ${user ? user.firstname + ' ' + user.lastname : 'Lade...'}`" />

    <TableTabs active="data" v-if="isManager" />

    <div class="row mt-4 mb-3">
      <div class="col-12">
        <Legend withTarget horizontal />
      </div>
    </div>
    <Accordion :title="tipe.name" :key="tipe.name" v-for="tipe of types">
      <div class="loading" v-if="loading">
        <div>Daten werden geladen...</div>
      </div>
      <div class="skilltable personal" v-if="!loading && filteredSkills(tipe.type).length > 0">
        <div class="row header" ref="header" :class="{ fixed }">
          <div class="col-12">
            <div class="row mt-3">
              <div class="col-12 namecontainer">
                <!-- <div v-if="fixed">
                  <div class="name">{{ user ? user.firstname + ' ' + user.lastname : 'Lade...' }}</div>
                  {{ tipe.name }}
                </div> -->
              </div>

              <div class="offset-6 col-6 mt-2 mb-2 filterbuttons">
                <UserDropdown
                  class="button"
                  v-if="gradingusers.length > 0"
                  :users="gradingusers"
                  @changed="filterTable"
                  :class="{ active: barTableFilter != 'avg' && barTableFilter != 'self' && barTableFilter != 'manager' && barTableFilter != 'set' }"
                />
                <button @click="filterTable('avg')" :class="{ active: barTableFilter == 'avg' }">
                  <Tooltip text="360° Feedback"
                    >Durschnitt aller Einschätzungen, die für den Skill abgegeben wurden, inklusive Führungskraft und Selbsteinschätzung.</Tooltip
                  >
                </button>
                <button @click="filterTable('set')" :class="{ active: barTableFilter == 'set' }">Abgestimmter Wert</button>
              </div>
            </div>
          </div>
        </div>

        <div class="row bartable" :key="`${skill}`" v-for="skill in filteredSkills(tipe.type)">
          <div class="col-4">
            <Skill
              :skill="skill"
              :isFuture="skill.future.includes(user.unit_id)"
              :isStrategic="skill.strategic.includes(user.unit_id)"
              :isLeadership="skill.leadership"
            />
          </div>

          <div class="col-8">
            <Bar
              :value="filteredBarTable[skill.id].value"
              :target="filteredBarTable[skill.id].target"
              :history="filteredBarTable[skill.id].history"
              v-if="filteredBarTable[skill.id]"
            />
          </div>
        </div>
      </div>
    </Accordion>

    <div class="row" v-if="user">
      <div class="col-8">
        <EntwicklungsPlan :unit="user.id" />
        <div class="outer-file-list" v-if="user.files.length > 0">
          <h3 v-if="user.files.length > 0">Dateien</h3>
          <FileList :files="JSON.parse(user.files)" v-if="user.files.length > 0" />
        </div>
        <div class="outer-file-list" v-hasperms="['user.all.manage', 'user.unit.manage', 'user.allbutceo.manage']">
          <h3>Projektzusammenarbeiten</h3>
          <Zusammenarbeit :user="user.id" />
        </div>
      </div>
      <div class="col-4">
        <Legend withTarget noheader />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import Accordion from '@/components/util/Accordion.vue';
import Bar from '@/components/Bar.vue';
import { useRouter } from 'vue-router';
import UserDropdown from '@/components/custom/UserDropdown.vue';
import { Emitter } from 'mitt';
import EntwicklungsPlan from '@/components/EntwicklungsPlan.vue';
import FileList from '@/components/FileList.vue';
import Zusammenarbeit from '@/components/custom/Zusammenarbeit.vue';
import TableTabs from '@/components/TableTabs.vue';

type GradeResult = {
  target?: number;
  set?: number;
  value?: number;
  leader?: number;
  self?: number;
  history?: number;
  history_set?: number;
  detailed?: {
    [propName: number]: number;
  };
};

export interface SkillRecord {
  id: number;
  name: string;
  description: string;
  group: 'personal' | 'social' | 'working';
  type: 1 | 2 | 3;
  strategic: Array<number>;
  future: Array<number>;
  leadership: boolean;
}

export default defineComponent({
  components: { Accordion, Bar, UserDropdown, EntwicklungsPlan, FileList, Zusammenarbeit, TableTabs },
  setup() {
    const store = useStore();
    const router = useRouter();
    const mitt = inject('emitter') as Emitter<{ awayfromdetails: string }>;
    const loading = ref(true);
    const fixed = ref(true);

    const barTableFilter = ref('avg');
    const skills = ref<Array<SkillRecord>>([]);
    const barTable = ref<{ [propName: number]: GradeResult }>({});
    const user = ref();
    const gradingusers = ref([]);
    const isManager = ref(false);

    const id = computed(() => {
      if (!Array.isArray(router.currentRoute.value.params.id)) return parseInt(router.currentRoute.value.params.id);
      return undefined;
    });

    onMounted(() => {
      store.dispatch('fetchPersonalGrades', id.value).then((res: any) => {
        barTable.value = res.result;
        user.value = { ...res.meta.user, unit_id: parseInt(res.meta.user.unit_id) };

        skills.value = res.meta.skills
          .sort(store.getters.getSort(user.value.unit_id))
          .filter((item: SkillRecord) => !item.leadership || res.meta.leadershipskills);
        gradingusers.value = res.meta.gradingusers;
        isManager.value = res.meta.isManager || false;
        loading.value = false;
      });
    });

    const filteredSkills = (type: 'personal' | 'social' | 'working') => {
      return skills.value.filter((item: SkillRecord) => item.group == type);
    };

    const filteredBarTable = computed(() => {
      const table: { [propType: string]: { value: number; target: number; history: number } } = {};
      for (const index in barTable.value) {
        const item = barTable.value[index];

        switch (barTableFilter.value) {
          case 'avg':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.value || -1, target: item.target || 0, history: item.history || -1 };
            break;
          case 'manager':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.leader || -1, target: item.target || 0, history: item.history || -1 };
            break;
          case 'set':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.set || -1, target: item.target || 0, history: item.history_set || -1 };
            break;
          case 'self':
            mitt.emit('awayfromdetails', '');
            table[index] = { value: item.self || -1, target: item.target || 0, history: item.history || -1 };
            break;
          default:
            table[index] = {
              value: item.detailed ? item.detailed[parseInt(barTableFilter.value)] : -1,
              target: item.target || 0,
              history: item.history || -1,
            };
            break;
        }
      }

      return table;
    });

    const filterTable = (filter: string) => {
      if (filter == '-1') {
        barTableFilter.value = 'avg';
      } else {
        barTableFilter.value = filter;
      }
    };

    const fullname = computed(() => {
      return '';
    });

    return {
      filterTable,
      types: store.getters.getTypes,
      loading,
      user,
      fixed,
      isManager,
      filteredBarTable,
      barTableFilter,
      filteredSkills,
      fullname,
      gradingusers,
    };
  },
});
</script>
